import API from "@/common/API";
import { FormatMoney } from "@/common/helpers";
import { parsedUser } from "@/common/GetCurrentUser";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import OrderTracePanel from "@/components/Documents/OrderTracePanel";

const OchoaDetails = ({ model }) => {
    const { t } = useTranslation("global");
    const user: any = parsedUser();
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [quotes, setQuotes] = useState([]);
    const [traceOrder, setTraceOrder] = useState(null);

    const bindData = async () => {
        try {
            setLoading(true);
            const request = await API.getAction(`placeDashboard/invoices?id=${model.id}`);
            if (request.status === 200) {
                setInvoices(request.data.response);
            }
            const quotesRequest = await API.getAction(`placeDashboard/quotes?id=${model.id}`);
            if (quotesRequest.status === 200) {
                setQuotes(quotesRequest.data.response);
            }
        } catch (ex) {
            // Error handled - request failed
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        bindData();
    }, [])
    return (
        <>
            {invoices.length > 0 && (
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="py-2">
                        <h5 className="display-5 mt-4">{t("Invoices")}</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("Invoice Number")}</th>
                                    <th>{t("Amount")}</th>
                                    <th>{t("Dispatched")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map((invoice) => (
                                    <tr key={invoice.id}>
                                        <td>{new Date(invoice.fecha).toLocaleDateString()}</td>
                                        <td>
                                            <button
                                                className="btn btn-link btn-sm p-0 text-decoration-none"
                                                title={t("Ver documentos relacionados")}
                                                onClick={() => setTraceOrder(invoice.factura)}
                                            >
                                                {invoice.factura}
                                            </button>
                                        </td>
                                        <td>RD$ {FormatMoney(invoice.valor)}</td>
                                        <td>{invoice.hasDispatch ?
                                            <span className="badge bg-success">{t("Yes")}</span> : <span className="badge bg-danger">{t("No")}</span>}</td>
                                    </tr>


                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>
            )}
            {quotes.length > 0 && (
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="py-2">
                        <h5 className="display-5 mt-4">{t("Quotes")}</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("Quote Number")}</th>

                                    <th>{t("Amount")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quotes.map((quote) => (
                                    <tr key={quote.id}>
                                        <td>{new Date(quote.fechaCotizacion).toLocaleDateString()}</td>
                                        <td>{quote.cotizacion}</td>

                                        <td>RD$ {FormatMoney(quote.montoCotizacion)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>)}

            <OrderTracePanel
                show={!!traceOrder}
                orderNumber={traceOrder || ""}
                organizationId={user?.OrganizationId}
                onHide={() => setTraceOrder(null)}
            />
        </>
    );
}
export default OchoaDetails;        
